<!-- <p-table #collectionTable [columns]="columns" [value]="collectionServicesList">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th
        *ngFor="let col of columns"
        [pSortableColumn]="col.type !== 'action' ? col.field : ''"
      >
        {{ col.header }}
        <p-sortIcon
          [field]="col.field"
          style="vertical-align: middle;"
          *ngIf="col.type !== 'action'"
        >
        </p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-service let-columns="columns">
    <tr>
      <td *ngFor="let col of columns; let i = index">
        <div *ngIf="col.type !== 'action'">
          {{
            col.type === 'date' ? (service[col.field] | date) :  service[col.field]
          }}
        </div>
        <div style="text-align: center;" *ngIf="col.type === 'action'">
          <p-checkbox
            [(ngModel)]="service['collected']"
            [binary]="true"
            (click)="setCollected(service)"
          ></p-checkbox>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table> -->

<div class="header-container">
  <div class="page-header">{{ tab === 'Collections' ? ('bikeshop.modal.update_job_card.tab.collections' | translate) : (
    'bikeshop.shop_profile.collections.deliveries' | translate) }}
  </div>
</div>

<div class="item-container">
  <div *ngFor="let item of collectionServicesList">
    <div>
      <div class="row">
        <div class="col-5 key">{{ 'general.jobcard_no' | translate }}:</div>
        <div class="col-7 value">{{ item.jobCardNo }}</div>
      </div>
      <div class="row">
        <div class="col-5 key">{{ 'bikeshop.shop_profile.collections.store_name' | translate }}:</div>
        <div class="col-7 value">{{ item.store }}</div>
      </div>
      <div class="row">
        <div class="col-5 key">{{ 'bikeshop.collections.name' | translate }}:</div>
        <div class="col-7 value">{{ item.customer }}</div>
      </div>
      <div class="row">
        <div class="col-5 key">{{ 'bikeshop.collections.contact_details' | translate }}:</div>
        <div class="col-7 value">{{ item.phoneNumber || item.email }}</div>
      </div>
      <div class="row">
        <div class="col-5 key">{{ 'bikeshop.collections.bike_model' | translate }}:</div>
        <div class="col-7 value">{{ item.bikeModel }}</div>
      </div>
      <div class="row">
        <div class="col-5 key">{{ 'bikeshop.collections.date' | translate }}:</div>
        <div class="col-7 value">{{ item.scheduleDate }}</div>
      </div>
      <div class="row">
        <div class="col-5 key">{{ 'bikeshop.collections.time' | translate }}:</div>
        <div class="col-7 value">{{item.timeSlot}}</div>
      </div>
      <div class="row">
        <div class="col-5 key">{{ 'bikeshop.collections.customer_notes' | translate }}:</div>
        <div class="col-7 value">{{ item.notes }}</div>
      </div>
      <div class="row">
        <div class="col-md-12 key">{{ 'bikeshop.collections.address' | translate }}:</div>
        <div class="col-md-12 value">{{ item.fullAddress }}</div>
      </div>
      <div class="row margin-top-16">
        <div class="col-5 key">{{ 'general.headers.status' | translate }}:</div>
        <div class="col-7 value">{{ item.statusID === 10 ? ('bikeshop.collections.collected' | translate) :
          item.statusID === 20 ? ('bikeshop.collections.delivered' | translate) : '' }}</div>
      </div>
    </div>
  </div>
</div>
